import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

const ICONS = ["gift", "book", "zap", "calendar", "star", "award"];

export default function EditBonus({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const add = () => set("items", [...(value.items || []), { title: "Novo bônus", description: "", value: "", icon: "gift" }]);
  const remove = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Bônus Exclusivos">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="bonus-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="bonus-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="bonus-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Bônus</span>
            <ListAddBtn onClick={add} label="Adicionar bônus" testId="bonus-add" />
          </div>
          <div className="space-y-4">
            {(value.items || []).map((b, i) => (
              <div key={i} data-testid={`bonus-row-${i}`} className="border border-border p-4 space-y-3">
                <div className="grid sm:grid-cols-3 gap-3">
                  <Field label="Ícone">
                    <select
                      data-testid={`bonus-icon-${i}`}
                      value={b.icon || "gift"}
                      onChange={(e) => setItem(i, "icon", e.target.value)}
                      className="w-full px-3 py-2.5 border border-border bg-white text-onyx text-sm focus:outline-none focus:border-gold"
                    >
                      {ICONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
                    </select>
                  </Field>
                  <div className="sm:col-span-2"><Field label="Título"><TextInput value={b.title} onChange={(v) => setItem(i, "title", v)} testId={`bonus-title-${i}`} /></Field></div>
                </div>
                <Field label="Descrição"><TextArea value={b.description} onChange={(v) => setItem(i, "description", v)} rows={2} testId={`bonus-description-${i}`} /></Field>
                <Field label="Valor (ex: R$ 97)"><TextInput value={b.value} onChange={(v) => setItem(i, "value", v)} testId={`bonus-value-${i}`} /></Field>
                <div className="flex justify-end"><ListRemoveBtn onClick={() => remove(i)} testId={`bonus-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
